export const prayerUnits = [
  {
    id: 'fiveFoldMinisters',
    translationKey: 'prayerUnits.units.fiveFold',
    internalName: 'Five Fold Ministers Prayer Unit'
  },
  {
    id: 'kidsPrayer79',
    translationKey: 'prayerUnits.units.kidsPrayer',
    internalName: "Children's Prayer Unit – Kids Prayer (7–9)"
  },
  {
    id: 'preteensPrayer1012',
    translationKey: 'prayerUnits.units.preteensPrayer',
    internalName: "Children's Prayer Unit – Preteens Prayer (10–12)"
  },
  {
    id: 'teensPrayer1318',
    translationKey: 'prayerUnits.units.teensPrayer',
    internalName: "Children's Prayer Unit – Teens Prayer (13–18)"
  },
  {
    id: 'youthPrayer1924',
    translationKey: 'prayerUnits.units.youthPrayer',
    internalName: 'Youth Prayer Unit – Youth Prayer (19–24)'
  },
  {
    id: 'youngAdultPrayer2534',
    translationKey: 'prayerUnits.units.youngAdultPrayer',
    internalName: 'Adult Prayer Unit – Young Adult Prayer (25–34)'
  },
  {
    id: 'middleAdultPrayer3564',
    translationKey: 'prayerUnits.units.middleAdultPrayer',
    internalName: 'Adult Prayer Unit – Middle Adult Prayer (35–64)'
  },
  {
    id: 'seniorsPrayer65',
    translationKey: 'prayerUnits.units.seniorsPrayer',
    internalName: 'Adult Prayer Unit – Seniors Prayer (65+)'
  },
  {
    id: 'primarySchoolMinistry',
    translationKey: 'prayerUnits.units.primarySchool',
    internalName: 'School Ministry Prayer Unit – Primary School'
  },
  {
    id: 'secondarySchoolMinistry',
    translationKey: 'prayerUnits.units.secondarySchool',
    internalName: 'School Ministry Prayer Unit – Secondary School'
  },
  {
    id: 'familyPrayerAltar',
    translationKey: 'prayerUnits.units.familyAltar',
    internalName: 'Family Prayer Altar'
  },
  {
    id: 'workplacePrayer',
    translationKey: 'prayerUnits.units.workplacePrayer',
    internalName: 'Workplace Prayer'
  },
  {
    id: 'prayingMothers',
    translationKey: 'prayerUnits.units.prayingMothers',
    internalName: 'Praying Mothers'
  },
  {
    id: 'harvestPrayer',
    translationKey: 'prayerUnits.units.harvestPrayer',
    internalName: 'Praying to the Lord of the Harvest'
  },
  {
    id: 'healingLand',
    translationKey: 'prayerUnits.units.healingLand',
    internalName: 'Praying for the Healing of the Land'
  },
  {
    id: 'antiCrime',
    translationKey: 'prayerUnits.units.antiCrime',
    internalName: 'Anti-Crime Prayer Unit'
  },
  {
    id: 'specialForces',
    translationKey: 'prayerUnits.units.specialForces',
    internalName: 'Special Forces Prayer Unit'
  },
  {
    id: 'gideonForce',
    translationKey: 'prayerUnits.units.gideonForce',
    internalName: 'Gideon Force'
  }
];

export const getPrayerUnitById = (id) => prayerUnits.find((unit) => unit.id === id);

export const getPrayerUnitName = (id) => {
  const unit = getPrayerUnitById(id);
  return unit ? unit.internalName : '';
};
